<!-- eslint-disable vue/html-self-closing -->
<template>
  <section class="issue-discussion">
    <div class="issue-discussion__author">
      <a
        class="image"
        :href="'/user/' + discussion?.author?.username"
      >
        <img
          :src="discussion?.author?.avatar"
          class="avatar"
          height="40"
          width="40"
        />
      </a>
    </div>
    <div class="issue-discussion__card">
      <div class="issue-discussion__header">
        <div class="issue-discussion__info">
          <div class="info">
            <a
              class="author"
              :href="'/user/' + discussion?.author?.username"
            >
              <b class="fullname">{{ discussion?.author?.fullName }}</b>
              <span class="username">@{{ discussion?.author?.username }}</span>
            </a>
            <small class="created-at">{{ $moment.utc(discussion.createdAt).fromNow() }}</small>
          </div>
        </div>
        <div
          v-if="canDeleteDiscussion || canEditDiscussion"
          class="issue-discussion__actions"
        >
          <button
            v-if="canEditDiscussion"
            class="btn btn-sm edit-discussion"
            @click="editDiscussion"
          >
            <i class="gf-icon gf-icon-pen"></i>
          </button>
          <button
            v-if="canDeleteDiscussion"
            class="btn btn-sm delete-discussion"
            @click="deleteDiscussion"
          >
            <i class="gf-icon gf-icon-trash"></i>
          </button>
        </div>
      </div>
      <div class="issue-discussion__content markdown-body">
        <div
          v-if="!isEditModeModel"
          v-html="discussion.message"
        ></div>
        <div
          v-else
          class="edit-discussion"
        >
          <gf-custom-text-editor
            ref="issueDiscussionEditor"
            editor-variant="editor"
            data-type="markdown"
            :data="discussion.rawMessage"
            :has-close-button="true"
            submit-btn-text="Отправить"
            placeholder="Напишите комментарий здесь"
            :has-error="hasError"
            :error-text="textError"
            @close="isEditModeModel = false"
            @submit="submitDisscussionEdit"
          ></gf-custom-text-editor>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import ACTION_ENUM from '@shared/modules/custom-roles/custom-roles.constants';
import IssueService from '@shared/modules/issue/issue.service';
import GfCustomTextEditor from '@/shared-modules/shared-components/shared/GfCustomTextEditor';
import { smallNotification } from '@/shared-modules/services/gf.notification.service';

export default {
  name: 'IssueDiscussion',
  components: {
    GfCustomTextEditor
  },
  props: {
    discussion: null
  },
  data() {
    return {
      isEditModeModel: false,
      hasError: false,
      textError: null
    };
  },
  computed: {
    alias() {
      return this.$route.params?.alias;
    },
    projectAlias() {
      return this.$route.params?.projectAlias;
    },
    issueId() {
      return this.$route.params?.issueId;
    },
    issue() {
      return this.$store.getters.getIssue || {};
    },
    canDeleteDiscussion() {
      const token = document.querySelector('head meta[name="uuid"]');
      if (!token) return;

      const uuid = token.content;
      const aid = this.discussion.author.id;

      return uuid === aid || this.getActionAvailabilityFlag(ACTION_ENUM.DELETE_ISSUE_NOTE);
    },
    canEditDiscussion() {
      const token = document.querySelector('head meta[name="uuid"]');
      if (!token) return;

      const uuid = token.content;

      return (
        uuid === this.discussion?.author?.id ||
        this.getActionAvailabilityFlag(ACTION_ENUM.EDIT_ISSUE_NOTE)
      );
    },
    ACTION_ENUM() {
      return ACTION_ENUM;
    }
  },
  methods: {
    getActionAvailabilityFlag(action) {
      return this.$store.getters.getActionAvailabilityFlag(action);
    },
    deleteDiscussion() {
      IssueService.deleteDiscussion(
        this.alias,
        this.projectAlias,
        this.issueId,
        this.discussion.id
      ).then(() => {
        this.$store.dispatch('deleteIssueDiscussionById', this.discussion?.id);
      });

      if (this.discussion.discussionUuid) {
        const item = e.target.closest('.issue-discussion');
        item.classList.add('--hidden');
      }
      this.$emit('deleteDiscussion', this.discussion);
    },
    editDiscussion() {
      if (this.discussion?.rawMessage[0] === '<')
        smallNotification('danger', { title: 'Невозможно отредактировать комментарий!' });
      else this.isEditModeModel = true;
    },
    async submitDisscussionEdit(data) {
      const editedComment = await data;
      if (editedComment === undefined) return;
      if (editedComment === null || editedComment?.length === 0) {
        this.hasError = true;
        this.textError = 'Комментарий не должен быть пустым';
      } else {
        this.hasError = false;
        IssueService.editDiscussion(
          this.alias,
          this.projectAlias,
          this.issueId,
          this.discussion.id,
          editedComment
        ).then((res) => {
          this.isEditModeModel = false;
          this.discussion.message = res?.message;
          this.discussion.rawMessage = editedComment;
        });
      }
    }
  }
};
</script>

<style lang="scss">
$this: '.issue-discussion';

#{$this} {
  width: 100%;
  max-height: 100000px;
  display: flex;
  gap: 8px;

  &.--hidden {
    max-height: 0;
    display: none !important;
  }

  & p {
    margin-bottom: 0 !important;
  }

  #{$this}__author {
    & > .image {
      & > .avatar {
        border-radius: 20px;
        cursor: pointer;
      }
    }
  }

  #{$this}__card {
    width: 100%;
    overflow: hidden;
    border: 1px solid var(--border-color);
    border-radius: 8px;

    #{$this}__header {
      padding: 9px 12px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 8px;
      background-color: var(--light);
      border-bottom: 1px solid var(--border-color);
      border-top-left-radius: 8px;
      border-top-right-radius: 8px;

      #{$this}__info {
        display: flex;
        align-items: center;
        gap: 4px;

        @include theme.max-xl {
          align-items: flex-start;
        }

        & > .info {
          display: flex;
          align-items: baseline;
          gap: 8px;

          @include theme.max-xl {
            flex-wrap: wrap;
            gap: 4px;
          }

          & > .author {
            display: flex;
            align-items: center;
            gap: 4px;
            flex-wrap: nowrap;
            white-space: nowrap;
            cursor: pointer;

            &:hover {
              & > * {
                color: var(--primary) !important;
              }
            }

            @include theme.max-sm {
              flex-wrap: wrap;
            }

            & > .fullname {
              max-width: 280px;
              color: var(--text);
              overflow: hidden;
              text-overflow: ellipsis;

              @include theme.max-xxl {
                max-width: 190px;
              }
            }
            & > .username {
              max-width: 280px;
              color: var(--text-muted);
              overflow: hidden;
              text-overflow: ellipsis;

              @include theme.max-xxl {
                max-width: 190px;
              }
            }
          }
          & > .created-at {
            color: var(--text-muted);
          }
        }
      }
      #{$this}__actions {
        display: flex;
        justify-content: flex-end;
        gap: 6px;

        & > button {
          padding: 0;
          min-height: 20px;
        }
        & > .edit-discussion {
          color: var(--text);

          &:hover {
            color: var(--text-muted);
          }
        }
        & > .delete-discussion {
          color: var(--danger);

          &:hover {
            color: #c82333;
          }
        }
      }
    }
    #{$this}__content {
      padding: 9px 12px;

      & > .edit-discussion {
        padding: 8px;
      }
    }
  }
}
</style>
